import { FETCH_MAILBOX, FETCH_CARDS, FETCH_CONVERSATION, SEND_MESSAGE, READ_MESSAGE, DELETE_MESSAGE } from './types'
import { MESSAGE_TYPES } from 'common/constants'
import { MAILBOX } from 'common/endpoints'

export const fetchMailbox = () => ({
  type: FETCH_MAILBOX,
  meta: { url: MAILBOX.INBOX },
})

export const fetchCards = () => ({
  type: FETCH_CARDS,
  meta: { url: MAILBOX.CARDS },
})

export const fetchConversation = nickname => ({
  type: FETCH_CONVERSATION,
  meta: { url: MAILBOX.conversation(nickname), nickname },
})

export const sendMessage = ({ to, message, cardId }) => ({
  type: SEND_MESSAGE,
  meta: {
    method: 'POST',
    url: MAILBOX.SEND,
    data: cardId
      ? { toUserId: to.id, cardId, messageTypeId: MESSAGE_TYPES.CARD }
      : { toUserId: to.id, subject: message, body: message },
    onSuccess: fetchConversation(to.nickname),
  },
})

// TODO - read all messages on conversation load
export const readMessage = message => ({
  type: READ_MESSAGE,
  meta: { method: 'PUT', url: MAILBOX.read(message) },
})

// Not used after discussion with PO
export const deleteMessage = (message, opponent) => ({
  type: DELETE_MESSAGE,
  meta: { method: 'PUT', url: MAILBOX.delete(message), onSuccess: fetchConversation(opponent.nickname) },
})
